var _defs, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "height_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".height_svg__cls-1,.height_svg__cls-2{fill:currentColor;stroke:currentColor;stroke-miterlimit:10}.height_svg__cls-2{fill:none;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "height_svg__Path_3",
    "data-name": "Path 3",
    className: "height_svg__cls-1",
    d: "M19 2.5L17 5h4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "height_svg__Path_3_Copy",
    "data-name": "Path 3 Copy",
    className: "height_svg__cls-1",
    d: "M19 21.5L17 19h4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "height_svg__Path_2_Copy",
    "data-name": "Path 2 Copy",
    className: "height_svg__cls-2",
    d: "M19 5v14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84 2.5H13a1 1 0 011 1v17a1 1 0 01-1 1H7a1 1 0 01-1-1V3.34a.84.84 0 01.84-.84z",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "height_svg__cls-2",
    d: "M11 6.5h3M11 12h3M11 17.5h3"
  })));
}

export default SvgHeight;


//////////////////
// WEBPACK FOOTER
// ./src/icons/height.svg
// module id = 840
// module chunks = 101